(() => {
  const WKT_EXCEL_PRODUCT_IDS = new Set(["10414347452602", "10414371406010", "10414372126906", "10414372257978", "10414372356282", "10414372683962", "10414372913338", "10414373011642", "10414373175482", "10414373241018", "10414373372090", "10414373437626", "10414373503162", "10414373568698", "10414373667002", "10414373798074", "10414373929146", "10414374027450", "10414374092986", "10414374191290", "10414374289594", "10414374355130", "10414374453434", "10414374518970", "10414374584506", "10414374650042", "10414374682810", "10414374748346", "10414374813882", "10414374879418", "10414371700922", "10414372061370", "10414372094138", "10414372159674", "10414372192442", "10414372225210", "10414372421818", "10414372487354", "10414372749498", "10414372847802", "10414373044410", "10414373142714", "10414373339322", "10414373535930", "10414373634234", "10414373765306", "10414373863610", "10414373994682", "10414374322362", "10414374486202", "10414374617274", "10414374715578", "10414374781114", "10414374846650", "10414374912186", "10414374944954", "10414375010490", "10414375043258", "10414375076026", "10414372290746", "10414372323514", "10414372389050", "10414372454586", "10414372585658", "10414372651194", "10414372716730", "10414372815034", "10414372880570", "10414372946106", "10414373077178", "10414373109946", "10414373208250", "10414373306554", "10414373404858", "10414373470394", "10414373601466", "10414373699770", "10414373732538", "10414373830842", "10414373961914", "10414374060218", "10414374125754", "10414374158522", "10414374224058", "10414374256826", "10414374387898", "10414374420666"]);
  const PAIR_CODE = 'WKT Pair & Save 15% Off';
  const ADD_ERROR_MESSAGE = 'We couldn’t confirm whether this item was added. Please check your cart before trying again.';
  let timer;
  let applying = false;
  let upsellLoading = false;
  let upsellTimer;

  const root = () => {
    const value = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return value.endsWith('/') ? value : value + '/';
  };

  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  };

  const getVisibleDrawer = () => {
    const customHeader = document.querySelector('cart-drawer .custom-header');
    return customHeader?.closest('cart-drawer') || document.querySelector('cart-drawer');
  };

  async function getCart() {
    const response = await fetch(root() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  }

  const formatAmountOnly = (cents) => {
    return ((Number(cents) || 0) / 100).toLocaleString(document.documentElement.lang || 'en', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  async function updateTotalCurrency(cart) {
    const drawer = getVisibleDrawer();
    if (!drawer || !cart) return;
    const totalEl = drawer.querySelector('[data-wkt-total-full]');
    const code = cart.currency || (window.Shopify?.currency?.active || '');
    const totalText = (code ? code + ' ' : '') + formatAmountOnly(cart.total_price);
    if (totalEl && totalEl.textContent !== totalText) totalEl.textContent = totalText;
  }

  async function updatePairPrices() {
    if (applying) return;
    applying = true;
    try {
      const cart = await getCart();
      const drawer = getVisibleDrawer();
      if (!drawer) return;
      updateTotalCurrency(cart);

      cart.items.forEach((item) => {
        const control = drawer.querySelector('[data-quantity-variant-id="' + item.variant_id + '"]');
        const row = control?.closest('.cart-item');
        if (!row) return;
        row.querySelectorAll('.wkt-pair-cart-price,.wkt-pair-role-badge').forEach(el => el.remove());
      });
    } catch (e) {
      console.warn('WKT Pair & Save cart display update skipped', e);
    } finally {
      applying = false;
    }
  }

  function ensureUpsellHost() {
    const drawer = getVisibleDrawer();
    if (!drawer) return null;
    let host = drawer.querySelector(':scope .wkt-meaningful-cart-upsell');
    if (host) return host;

    const footer = drawer.querySelector('.drawer__footer');
    const items = drawer.querySelector('cart-drawer-items');
    if (!footer && !items) return null;

    host = document.createElement('section');
    host.className = 'wkt-meaningful-cart-upsell';
    host.setAttribute('aria-label', 'Meaningful play recommendation');
    host.innerHTML = `
      <div class="wkt-meaningful-cart-upsell__head">
        <span class="wkt-pair-ticket">🎟️</span>
        <div>
          <h3>Complete your learning bundle</h3>
          <p data-wkt-next-tier></p>

        </div>
      </div>
      <div class="wkt-meaningful-cart-upsell__product" aria-live="polite"></div>
    `;

    if (footer) footer.parentNode.insertBefore(host, footer);
    else items.insertAdjacentElement('afterend', host);
    return host;
  }

  function chooseAnchor(cart) {
    const items = (Array.isArray(cart.items) ? cart.items : []).filter(item =>
      Number(item.variant_id) !== 46362540015802 && String(item.product_id) !== '8485926600890'
    );
    return items.find(item => {
      const title = String(item.product_title || item.title || '');
      const role = item.properties && item.properties._wkt_pair_role;
      return !/digital learning vault|free us\$99/i.test(title) && role !== 'upsell';
    }) || items.find(item => !/digital learning vault|free us\$99/i.test(String(item.product_title || item.title || '')));
  }

  async function fetchRecommendation(productId, intent) {
    const url = new URL(root() + 'recommendations/products', window.location.origin);
    url.searchParams.set('section_id', 'wkt-cart-upsell-recommendations');
    url.searchParams.set('product_id', String(productId));
    url.searchParams.set('limit', '8');
    url.searchParams.set('intent', intent);
    const response = await fetch(url.toString(), { credentials:'same-origin', headers:{Accept:'text/html'} });
    if (!response.ok) return null;
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const result = doc.querySelector('[data-wkt-upsell-results]');
    return result?.querySelector('.upsell-product') || null;
  }

  async function loadMeaningfulUpsell() {
    if (upsellLoading) return;
    const host = ensureUpsellHost();
    if (!host) return;
    const productHost = host.querySelector('.wkt-meaningful-cart-upsell__product');
    upsellLoading = true;
    try {
      const cart = await getCart();
      if (!cart.items || !cart.items.length) {
        host.hidden = true;
        productHost.replaceChildren();
        return;
      }
      const nextTier = host.querySelector('[data-wkt-next-tier]');
      if (nextTier) nextTier.textContent = 'Any eligible savings are reflected in your cart total.';
      const anchor = chooseAnchor(cart);
      if (!anchor) {
        host.hidden = true;
        productHost.replaceChildren();
        return;
      }

      let card = await fetchRecommendation(anchor.product_id, 'complementary');
      if (!card) card = await fetchRecommendation(anchor.product_id, 'related');
      if (!card) {
        host.hidden = true;
        productHost.replaceChildren();
        return;
      }

      productHost.replaceChildren(card);
      host.hidden = false;
    } catch (e) {
      console.warn('WKT meaningful cart recommendation skipped', e);
      host.hidden = true;
    } finally {
      upsellLoading = false;
    }
  }

  function scheduleUpsell() {
    clearTimeout(upsellTimer);
    upsellTimer = setTimeout(loadMeaningfulUpsell, 220);
  }

  document.addEventListener('change', event => {
    const selector = event.target.closest('.wkt-meaningful-cart-upsell .upsell-product__variant-selector');
    if (!selector) return;
    const option = selector.options[selector.selectedIndex];
    const card = selector.closest('.upsell-product');
    const image = card?.querySelector('.upsell-product-image');
    const button = card?.querySelector('.upsell-add-button');
    const price = card?.querySelector('[data-wkt-upsell-price]');
    const discountedPrice = card?.querySelector('[data-wkt-upsell-discounted-price]');
    const compare = card?.querySelector('[data-wkt-upsell-compare]');
    if (image && option.dataset.imageUrl) image.src = option.dataset.imageUrl;
    if (button) button.dataset.productId = option.value;
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (discountedPrice && option.dataset.discountedPrice) discountedPrice.textContent = option.dataset.discountedPrice;
    if (compare) {
      compare.hidden = option.dataset.onSale !== 'true';
      const s = compare.querySelector('s');
      if (s && option.dataset.compareAt) s.textContent = option.dataset.compareAt || '';
    }
  });

  document.addEventListener('click', async event => {
    const button = event.target.closest('.wkt-meaningful-cart-upsell .upsell-add-button');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const variantId = Number(button.dataset.productId);
    if (!variantId) return;
    const previousError = getVisibleDrawer()?.querySelector('#CartDrawer-CartErrors');
    if (previousError?.textContent === ADD_ERROR_MESSAGE) previousError.textContent = '';
    const original = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'ADDING…';
    try {
      const response = await fetch(root() + 'cart/add.js', {
        method:'POST',
        credentials:'same-origin',
        headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({items:[{id:variantId,quantity:1,properties:{_wkt_pair_role:'upsell'}}]})
      });
      if (!response.ok) throw new Error('Unable to add recommendation');
      const drawer = getVisibleDrawer();
      if (drawer && typeof drawer.updateCart === 'function') {
        drawer.updateCart();
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
      setTimeout(() => {
        updatePairPrices();
        scheduleUpsell();
      }, 700);
    } catch (e) {
      console.warn('WKT recommendation add failed', e);
      const errorMessage = getVisibleDrawer()?.querySelector('#CartDrawer-CartErrors');
      if (errorMessage) errorMessage.textContent = ADD_ERROR_MESSAGE;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = original;
    }
  }, true);

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(updatePairPrices, 120);
    scheduleUpsell();
  }

  const style = document.createElement('style');
  style.textContent = `
    cart-drawer .cart-item__price.wkt-pair-original-price-hidden { display:none !important; }
    cart-drawer .wkt-pair-cart-price { margin-top:.55rem; }
    cart-drawer .wkt-pair-cart-price__prices { display:flex; align-items:baseline; gap:.7rem; flex-wrap:wrap; }
    cart-drawer .wkt-pair-cart-price__prices s { color:rgba(var(--color-foreground),.55); font-size:1.35rem; }
    cart-drawer .wkt-pair-cart-price__prices strong { color:rgb(var(--color-foreground)); font-size:1.75rem; line-height:1.2; }
    cart-drawer .wkt-pair-cart-price__saving { margin-top:.2rem; font-size:1.2rem; font-weight:700; color:#9a4f16; }
    cart-drawer .wkt-meaningful-cart-upsell { flex:0 0 auto; margin:0 1.2rem 1rem; padding:.95rem; border:1px solid rgba(245,118,86,.32); border-radius:16px; background:linear-gradient(145deg,#fffaf6 0%,#fff 100%); box-shadow:0 6px 18px rgba(24,33,61,.05); }
    cart-drawer .wkt-meaningful-cart-upsell[hidden] { display:none !important; }
    cart-drawer .wkt-meaningful-cart-upsell__head { display:grid; grid-template-columns:34px minmax(0,1fr); gap:.7rem; align-items:start; margin-bottom:.65rem; }
    cart-drawer .wkt-meaningful-cart-upsell__head .wkt-pair-ticket { display:grid; place-items:center; width:34px; height:34px; border-radius:9px; background:#ffe9ee; font-size:1.55rem; }
    cart-drawer .wkt-meaningful-cart-upsell__head h3 { margin:0; color:#18213d; font-size:1.28rem; line-height:1.16; font-weight:850; }
    cart-drawer .wkt-meaningful-cart-upsell__head h3 strong { color:#e94163; }
    cart-drawer .wkt-meaningful-cart-upsell__head p { margin:.24rem 0 0; color:#6f778c; font-size:.94rem; line-height:1.3; }
    cart-drawer .wkt-upsell-top-discount { display:inline-flex; margin-top:.35rem; padding:.24rem .52rem; border-radius:999px; background:#eaf8f0; color:#176b59; font-size:.82rem; font-weight:900; line-height:1.15; }
    cart-drawer .wkt-meaningful-cart-upsell .upsell-product { display:grid; grid-template-columns:64px minmax(0,1fr) 94px; grid-template-areas:"image details button"; gap:.65rem; align-items:center; padding:.8rem; border:1px solid rgba(24,33,61,.09); border-radius:14px; background:#fff; box-shadow:0 5px 14px rgba(24,33,61,.05); }
    cart-drawer .wkt-meaningful-cart-upsell .upsell-product__image { grid-area:image; display:block; width:64px; height:64px; overflow:hidden; border-radius:11px; }
    cart-drawer .wkt-meaningful-cart-upsell .upsell-product__image img { width:100%; height:100%; object-fit:cover; }
    cart-drawer .wkt-meaningful-cart-upsell .upsell-product__details { grid-area:details; min-width:0; }
    cart-drawer .wkt-meaningful-cart-upsell .wkt-auto-upsell-title { display:-webkit-box; overflow:hidden; color:#18213d; font-size:1rem; font-weight:780; line-height:1.2; text-decoration:none; -webkit-box-orient:vertical; -webkit-line-clamp:2; }

    cart-drawer .wkt-meaningful-cart-upsell .upsell-product__price { display:flex; gap:.42rem; align-items:baseline; margin-top:.2rem; flex-wrap:wrap; }
    cart-drawer .wkt-meaningful-cart-upsell .wkt-upsell-regular-price { color:#7c8496; }
    cart-drawer .wkt-meaningful-cart-upsell .wkt-upsell-discounted-price { color:#176b59 !important; font-weight:900 !important; }
    cart-drawer .wkt-meaningful-cart-upsell .upsell-product__price p { margin:0; font-size:1.02rem; }
    cart-drawer .wkt-meaningful-cart-upsell .upsell-product__variant-selector { width:100%; min-height:2.65rem; margin-top:.35rem; border:1px solid rgba(24,33,61,.13); border-radius:8px; background:#fff; font-size:.9rem; }
    cart-drawer .wkt-meaningful-cart-upsell .upsell-product__button { grid-area:button; display:flex; flex-direction:column; gap:.35rem; align-items:stretch; }
    cart-drawer .wkt-meaningful-cart-upsell .upsell-add-button { width:94px; min-height:3.35rem; padding:.55rem .65rem; border:0; border-radius:10px; background:#18213d; color:#fff; font-size:.94rem; font-weight:800; line-height:1.12; }
    cart-drawer .wkt-meaningful-cart-upsell .upsell-product__button::after { display:none; content:none; }
    @media(max-width:390px){
      cart-drawer .wkt-meaningful-cart-upsell{margin-inline:.9rem;padding:.8rem}
      cart-drawer .wkt-meaningful-cart-upsell .upsell-product{grid-template-columns:56px minmax(0,1fr) 84px;gap:.55rem;padding:.7rem}
      cart-drawer .wkt-meaningful-cart-upsell .upsell-product__image{width:56px;height:56px}
      cart-drawer .wkt-meaningful-cart-upsell .upsell-add-button{width:84px;min-height:3.1rem;font-size:.88rem}
      cart-drawer .wkt-meaningful-cart-upsell__head h3{font-size:1.2rem}
    }
  `;
  document.head.appendChild(style);

  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:refresh', schedule);

  const observer = new MutationObserver((mutations) => {
    if (applying) return;
    const relevant = mutations.some(m => {
      const target = m.target instanceof Element ? m.target : m.target.parentElement;
      // Timer text changes every second; they do not change cart state.
      // Keep structural cart/header replacements observable by filtering the target,
      // not added nodes, so a refreshed drawer that contains the timer still updates.
      return target && target.closest && target.closest('cart-drawer') &&
        !target.closest('.wkt-meaningful-cart-upsell') &&
        !target.closest('[data-wkt-mixmatch-countdown]');
    });
    if (relevant) schedule();
  });
  const startObserver = () => {
    const drawer = getVisibleDrawer();
    if (drawer) observer.observe(drawer, { childList:true, subtree:true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startObserver);
  else startObserver();
})();